@if (isEditMode) {
  <div class="edit-mode">
    <form [formGroup]="editForm">
      <span class="label">{{ label }}</span>
      <div class="button-container">
        <button
          mat-flat-button
          color="primary"
          (click)="onSaveClicked()"
          [disabled]="!(editForm.valid && editForm.dirty)"
        >
          <mat-icon class="md-18">check</mat-icon> Save
        </button>
        <button
          type="button"
          mat-stroked-button
          (click)="toggleEditMode(false)"
        >
          <mat-icon class="md-18">close</mat-icon> Cancel
        </button>
      </div>
      <div class="value-description">
        <rich-text-editor
          [form]="editForm"
          field="description"
          [getFocusWhenStart]="true"
        ></rich-text-editor>
      </div>
    </form>
  </div>
} @else {
  <div class="read-mode">
    <span class="label">{{ label }}</span>
    <div class="value-description" [innerHTML]="description | safeHtml"></div>
    <div class="button-container">
      <button mat-stroked-button (click)="toggleEditMode(true)">
        <mat-icon class="md-18">edit</mat-icon> Edit
      </button>
    </div>
  </div>
}
